import React from 'react'
import useStyles from './Style'
import Required from './Required'
import Uploaded from './Uploaded'

const List: React.FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <Required />
      <Uploaded />
    </div>
  )
}

export default List
